import { useSelector } from "react-redux";
import { SearchResultBuilder } from "../objects/SearchResultBuilder";
import moment from "moment";
import _ from "lodash";
import { stripEmTagFromHtml } from "../../../../../../_helpers";
import SearchDate from "../SearchDate";

export default function useGetSearchResult() {
  const { loading, searchData } = useSelector((state) => state.search);
  const totalCount = searchData?.resultCount || 0;
  const rows = [];

  if (!loading && searchData?.searchResult?.length > 0) {
    searchData?.searchResult?.map((item) => {
      const builder = new SearchResultBuilder();
      let phrase = stripEmTagFromHtml(item.phrase);

      builder.setId(_.get(item, "messageId") || "-");
      builder.setMessage(phrase);
      builder.setDate(
        <SearchDate
          text={moment(_.get(item, "messageDate")).format("MMM D, YYYY") || "-"}
        />,
      );
      const returnTo = `${window.location.pathname}${window.location.search}`;
      builder.setParam(
        `/analyze/${_.get(item, "messageId")}?platform=trends&returnTo=${encodeURIComponent(
          returnTo,
        )}`,
      );

      rows.push(builder.search);
    });
  }

  const columns = [
    {
      id: "message",
      label: "Message",
      width: 500,
      clickable: true,
      isSortable: false,
      withTooltip: false,
    },
    { id: "date", label: "Date", width: 80, align: "right" },
  ];

  return {
    rows,
    columns,
    totalCount,
    loading,
  };
}
